import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  adjustToTimeZoneSafely,
  type RrcEp9WasteProfile,
} from '@ots-frontend/ots-data';
import { RrcEp9WasteProfileInspector } from '@ots-frontend/ots-ui-tw';
import type { RrcEp9WasteProfileFormDefaultValues } from '../rrc-profile-route-defaults';

type Props = {
  id?: string;
  tenantCode?: string;
  copy?: boolean;
  formDefaults?: RrcEp9WasteProfileFormDefaultValues;
};

/** Preserve legacy navigation defaults while the shared form works with plain API values. */
export const ep9WasteProfileRouteDefaults = (
  value?: RrcEp9WasteProfileFormDefaultValues
): Partial<RrcEp9WasteProfile> | undefined =>
  value
    ? {
        objectId: value.object?.id,
        objectType: value.object?.type,
        effectiveStartDttm: adjustToTimeZoneSafely(
          value.effectiveStartDate
        )?.getTime(),
        effectiveEndDttm: adjustToTimeZoneSafely(
          value.effectiveEndDate
        )?.getTime(),
        wasteType: value.wasteType?.code,
        wastePhysicalCharacteristics: value.wastePhysicalCharacteristics?.code,
        wasteClassification: value.wasteClassification?.code,
        wasteBasis: value.wasteBasis?.code,
        wasteNormReading: value.wasteNormReading,
        wasteChemicalCharacteristics: value.wasteChemicalCharacteristics,
        wasteConstituents: value.wasteConstituents,
        rcraExempt: value.rcraExempt,
        contactName: value.contactName,
        contactPhone: value.contactPhone,
        contactEmail: value.contactEmail,
      }
    : undefined;

export const RrcEp9WasteProfileFormPageRoute = () => {
  const { state } = useLocation();
  const [params] = useSearchParams();
  return (
    <RrcEp9WasteProfileFormPage
      id={state?.id ?? params.get('id') ?? undefined}
      tenantCode={state?.tenantCode ?? params.get('tenantCode') ?? undefined}
      copy={state?.copy}
      formDefaults={state?.formDefaults}
    />
  );
};
export const RrcEp9WasteProfileFormPage = ({
  id,
  tenantCode,
  copy,
  formDefaults,
}: Props) => {
  const navigate = useNavigate();
  return (
    <RrcEp9WasteProfileInspector
      id={id}
      tenantCode={tenantCode}
      initialMode={copy ? 'copy' : id ? 'edit' : 'create'}
      defaults={ep9WasteProfileRouteDefaults(formDefaults)}
      objectLocked={!!formDefaults?.object}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
